import React from "react";
import { Container, Row, Col } from "reactstrap";
import img1 from "../../assets/images/logo-light.png";
import Countdown from "react-countdown";
import { Link } from "react-router-dom";

import Breadcrumbs from "../../components/Common/Breadcrumb";

const ComingSoon = () => {

  document.title = "Coming Soon | RS-CRM";

  const authUser = JSON.parse(localStorage.getItem("authUser"))?.response;

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return <span>You are good to go!</span>;
    } else {
      return (
        <>
          <div className="coming-box">
            {days} <span>Days</span>
          </div>
          <div className="coming-box">
            {hours} <span>Hours</span>
          </div>
          <div className="coming-box">
            {minutes} <span>Minutes</span>
          </div>
          <div className="coming-box">
            {seconds} <span>Seconds</span>
          </div>
        </>
      );
    }
  };

  // -------------------------
  // Logged in layout
  // -------------------------

  if (authUser) {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs title="RS CRM" breadcrumbItem="Coming Soon" />

            <Row className="justify-content-center">
              <Col lg={6}>
                <div className="text-center mt-5">

                  <h3 className="mb-3">🚧 Coming Soon</h3>

                  <p className="text-muted">
                    This feature is under development and will be available soon.
                  </p>

                  <div className="d-flex justify-content-center mt-4 counter-number">
                    <Countdown
                      date="2024/12/01"
                      renderer={renderer}
                    />
                  </div>

                </div>
              </Col>
            </Row>

          </Container>
        </div>
      </React.Fragment>
    );
  }

  // -------------------------
  // Public layout
  // -------------------------

  return (
    <React.Fragment>
      <div className="bg-pattern" style={{ height: "100vh" }}>
        <div className="bg-overlay"></div>

        <div className="account-pages pt-5">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mb-5 mt-5">

                  <Link to="/#" className="logo">
                    <img src={img1} height="24" alt="logo" />
                  </Link>

                  <h5 className="font-size-16 text-white-50 mb-4">
                    RS-CRM
                  </h5>

                  <h4 className="text-white mt-5">
                    Let's get started with RS-CRM
                  </h4>

                  <p className="text-white-50">
                    This feature will be available soon.
                  </p>

                  <Row className="justify-content-center mt-5">
                    <Col md={8}>
                      <div className="counter-number">
                        <Countdown
                          date="2024/12/01"
                          renderer={renderer}
                        />
                      </div>
                    </Col>
                  </Row>

                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ComingSoon;